import { useState } from "react";
import { User } from "../../features/services/user/User.type";
import {
  validateContactDetails,
  validatePersonalDetails,
  validateUserField,
} from "../../features/services/user/UserValidation";

const useUserForm = (initialUser: User) => {
  const [errors, setErrors] = useState({
    personalDetails: {} as Record<string, string>,
    contactDetails: {} as Record<string, string>,
  });

  const [currentUser, setCurrentUser] = useState<User>(initialUser);

  const handleSave = (saveCallback: any) => {
    var contactErrors = validateContactDetails(currentUser);
    var personalErrors = validatePersonalDetails(currentUser);
    const newErrors: any = {
      personalDetails: {},
      contactDetails: {},
    };

    if (contactErrors || personalErrors) {
      if (contactErrors && contactErrors.inner) {
        contactErrors.inner.forEach((validationError: any) => {
          const field = validationError.path;
          if (field) {
            newErrors.contactDetails[field] = validationError.message;
          }
        });
      }

      if (personalErrors && personalErrors.inner) {
        personalErrors.inner.forEach((validationError: any) => {
          const field = validationError.path;
          if (field) {
            newErrors.personalDetails[field] = validationError.message;
          }
        });
      }
      setErrors(newErrors);
    } else {
      saveCallback(currentUser);
    }
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const [section, field] = name.split(".");
    if (section && field) {
      const errorMessage = await validateUserField(section, field, value);

      setErrors((prevErrors) => ({
        ...prevErrors,
        personalDetails: {
          ...prevErrors.personalDetails,
          ...(section === "personalDetails" ? { [field]: errorMessage } : {}),
        },
        contactDetails: {
          ...prevErrors.contactDetails,
          ...(section === "contactDetails" ? { [field]: errorMessage } : {}),
        },
      }));
    }

    setCurrentUser((prevUser: User) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const handleRowClick = (row: any) => {
    setCurrentUser(row);
    setErrors({ contactDetails: {}, personalDetails: {} });
  };

  return {
    currentUser,
    setCurrentUser,
    handleSave,
    errors,
    setErrors,
    handleInputChange,
    handleRowClick,
  };
};

export default useUserForm;
